import styled from "styled-components/macro";

export const Hint = styled.div`
  margin-top: 8px;
  font-size: 14px;
  color: #b3b3b3;
`;
